module.exports = __webpack_public_path__ + "img/logo-tr.070085da.png";